export function init($name = '') {
    const checkbox = $($name);

    if (!checkbox.length) {
        return;
    }

    checkbox.click(function() {
        const parent = $(this).parents($name + '-parent');

       if ($(this).prop('checked')) {
           parent.find($name + '-non').addClass('is-hidden').find('input').val('').removeAttr('required');
           parent.find($name + '-checked').removeClass('is-hidden').find('input').attr('required', 'required');
           return;
       }

        parent.find($name + '-non').removeClass('is-hidden').find('input').attr('required', 'required');
        parent.find($name + '-checked').addClass('is-hidden').find('input').val('').removeAttr('required');
    });
}